// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectedInput_wrapper__3_6g-","dropdownList":"SelectedInput_dropdownList__30Z0R","selectedItem":"SelectedInput_selectedItem__3HNVI","menu-":"SelectedInput_menu-__HJgR6"};